<!--  -->
<template>
  <div class="page">
    <img style="width: 100%" src="/static/img/wx_link.png" v-if="Mtype==1"/>
    <img style="width: 100%" src="/static/img/wx_ios.png" v-if="Mtype==2"/>
    <img style="width: 100%" src="/static/img/wx_foot.png" alt="" />
  </div>
</template>

<script>
import {
  VueFlux,
  FluxCaption,
  FluxControls,
  FluxIndex,
  FluxPagination,
  FluxPreloader,
} from "vue-flux";
export default {
  name: "download",
  data() {
    return {
      Mtype: 0,
    };
  },
  computed: {},
  mounted() {},
  methods: {},
  created() {
    console.log('download.vue created')
    var sUserAgent = navigator.userAgent.toLowerCase();
    var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
    var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
    //var bIsMidp = sUserAgent.match(/midp/i) == "midp";
    if( bIsIpad || bIsIphoneOs ){
        this.Mtype = 2;
    } else {
        if(sUserAgent.match(/MicroMessenger/i) == 'micromessenger'){
            this.Mtype = 1;
        } else{
            window.location.href = 'https://comtcare-pub.oss-cn-hangzhou.aliyuncs.com/apk/app-release.apk';
        }
    }
  },
};
</script>
<style lang='less' scoped>
.page {
  position: fixed;
  min-height: 100%;
  width: 100%;
  background-color: #0e2659 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/download.vue